<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="$options.titleText"
    :successless="isSuccessless"
    @closed="$emit('closed')"
    @submit="onSubmit"
  >
    <v-overlay
      :value="isLoading"
      absolute
      color="white"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-overlay>

    <div v-if="isSuccessless">
      В данной процедуре невозможно осуществить перевод ответов в баллы
    </div>
    <div v-else>
      <v-card
        v-for="position in positions"
        :key="position.id"
        class="d-flex align-center mt-2"
      >
        <v-checkbox
          v-model="selected[position.position]"
          :label="position.position.toString()"
          hide-details
          class="pa-2 ma-0"
          :disabled="position.question_type !== 'ILI_EXT_ACCORD'"
        />
        <span v-text="position.question_type" />
      </v-card>
    </div>
  </BModalConfirm>
</template>

<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import { MarksApi, QuestionsApi } from '@/api/resources/Marks'
import { keys, pickBy, toNumber } from 'lodash'

export default {
  components: {
    BModalConfirm,
  },
  titleText: 'Перевод ответов в баллы',
  props: {
    procedureId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    positions: [],
    selected: {},
  }),
  computed: {
    isSuccessless() {
      return !this.isLoading && this.positions.length <= 0
    },
    result() {
      return keys(pickBy(this.selected)).map((el) => toNumber(el))
    },
  },
  methods: {
    async asyncData() {
      this.isLoading = true

      const api = new QuestionsApi()
      try {
        const { data } = await api.positions(this.procedureId)
        this.positions = data
      } catch (e) {
        this.$notice.errors(e)
      }

      this.isLoading = false
    },
    async onSubmit() {
      this.isLoading = true

      const api = new MarksApi()
      try {
        await api.calculate({
          procedure_id: this.procedureId,
          positions_list: this.result,
        })
        this.$notice.info('После завершения процесса вы получите сообщение в разделе уведомления')
      } catch (e) {
        this.$notice.errors(e)
      }

      this.isLoading = false
    },
    open() {
      return this.$refs.modal.open()
    },
    close(...args) {
      return this.$refs.modal.close(...args)
    },
  },
}
</script>
